import { render, staticRenderFns } from "./Custody.vue?vue&type=template&id=50395c1a&scoped=true"
import script from "./Custody.vue?vue&type=script&lang=js"
export * from "./Custody.vue?vue&type=script&lang=js"
import style0 from "./Custody.vue?vue&type=style&index=0&id=50395c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50395c1a",
  null
  
)

export default component.exports